import { connect, ConnectedProps } from 'react-redux'
import TableAddons from '../../../../../../../../specificComponents/Product/Tables/TableAddons'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'

type AddonListingModalProps = ReduxTableAddons & ModalEditComponentProps &{}

const AddonListingModal: React.FC<AddonListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableAddonsConnect setTableInstance={() => { }} userPermissions={getUserPermissions('product.addon.stock') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const tableAddonsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapTableAddonsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const tableAddonsConnect = connect(mapTableAddonsConnector, tableAddonsDispatch)
type ReduxTableAddons = ConnectedProps<typeof tableAddonsConnect>

const tableAddonsConnectLoading = withLoading(TableAddons, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TableAddonsConnect = tableAddonsConnect(tableAddonsConnectLoading)

export default AddonListingModal